export interface CommonModalDialogOption {
  header: boolean;
  title: string;
  isErrorMessage: boolean;
  message: string;
  subMessages: string[];
  buttonType: ModalDialogButtonType;
};

export enum CommonModalDialogType {
  INFO = "Information",
  WARNING = "Warning",
  ERROR = "Error"
};

export enum ModalDialogButtonType {
  YES_NO = "YesNo",
  OK_CANCEL = "OkCancel",
  CLOSE = "Close"
};

export enum ModalDialogResult {
  YES = "Yes",
  NO = "No",
  OK = "Ok",
  CANCEL = "Cancel",
  CLOSE = "Close"
}
